import { ReactNode } from "react";
import styles from "./ButtonBar.module.scss";

interface ButtonBarProps {
  children: ReactNode;
  className?: string;
}

const ButtonBar = ({ className, children }: ButtonBarProps) => (
  <div className={`${styles.buttonbar} ${className}`}>{children}</div>
);

export default ButtonBar;
